import React from 'react'
import Switch, { SwitchProps } from '@material-ui/core/Switch'
import Grid from '@material-ui/core/Grid'
import styled from 'styled-components'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import cn from 'classnames'

interface ICustomSwitchBaseProps extends SwitchProps {
  customStyle?: {
    checkedColor?: string
    trackColor?: string
    backgroundColor?: string
    border?: string
    height?: string
  }
}

export interface ICustomSwitchProps extends ICustomSwitchBaseProps {
  labelLeft?: string
  labelRight?: string
  disabled?: boolean
}

const StyledSwitch = styled(({ ...props }) => <Switch {...props} />)(
  ({ customStyle = {} }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: customStyle?.checkedColor || 'black'
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: customStyle?.trackColor || 'white'
    },
    '& .MuiSwitch-track': {
      backgroundColor: customStyle?.backgroundColor || 'black',
      opacity: 1,
      border: customStyle?.border || '1px solid black',
      height: customStyle?.height || 'auto'
    }
  })
)

export default function CustomSwitch({
  labelLeft,
  labelRight,
  disabled,
  checked,
  onChange,
  ...switchProps
}: ICustomSwitchProps): JSX.Element {
  return (
    <div>
      <Grid
        component='label'
        container
        alignItems='center'
        className={cn({ disabled: disabled })}
      >
        <Grid item>
          <Typography variant={'captionDarkGrey'}>{labelLeft}</Typography>
        </Grid>
        <Grid item>
          <StyledSwitch
            size={'small'}
            checked={checked}
            onChange={onChange}
            {...switchProps}
          />
        </Grid>
        <Grid item>
          <Typography variant={'captionDarkGrey'}>{labelRight}</Typography>
        </Grid>
      </Grid>
    </div>
  )
}
